import { useField } from 'formik';

import { controlError } from 'utils';

import { Input, InputProps } from '../input';

export interface InputFieldProps extends Omit<InputProps, 'name'> {
  name: string;
  label?: string;
  onChange?: InputProps['onChange'];
}

export function InputField({
  name,
  label,
  onBlur,
  onChange,
  ...props
}: InputFieldProps) {
  const [field, meta] = useField<string>(name);

  const errorText = controlError(meta, name, label);

  return (
    <Input
      {...props}
      {...field}
      label={label}
      error={!!errorText}
      helperText={errorText}
      onBlur={(event) => {
        field.onBlur(event);
        onBlur?.(event);
      }}
      onChange={(event) => {
        field.onChange(event);
        onChange?.(event);
      }}
    />
  );
}
